import React from 'react';

const ThreeDotsIconImage = () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7496_194022)">
      <g clipPath="url(#clip1_7496_194022)">
        <path
          d="M10.5645 6.09115C11.479 6.09115 12.2204 5.34495 12.2204 4.42448C12.2204 3.504 11.479 2.75781 10.5645 2.75781C9.64995 2.75781 8.90857 3.504 8.90857 4.42448C8.90857 5.34495 9.64995 6.09115 10.5645 6.09115Z"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          d="M10.5645 11.9232C11.479 11.9232 12.2204 11.177 12.2204 10.2565C12.2204 9.33604 11.479 8.58984 10.5645 8.58984C9.64995 8.58984 8.90857 9.33604 8.90857 10.2565C8.90857 11.177 9.64995 11.9232 10.5645 11.9232Z"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          d="M10.5645 17.7591C11.479 17.7591 12.2204 17.0129 12.2204 16.0924C12.2204 15.172 11.479 14.4258 10.5645 14.4258C9.64995 14.4258 8.90857 15.172 8.90857 16.0924C8.90857 17.0129 9.64995 17.7591 10.5645 17.7591Z"
          fill="black"
          fillOpacity="0.3"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_7496_194022">
        <rect width="19.871" height="20" fill="white" transform="translate(0.629028 0.257812)" />
      </clipPath>
      <clipPath id="clip1_7496_194022">
        <rect width="19.871" height="20" fill="white" transform="translate(0.629028 0.257812)" />
      </clipPath>
    </defs>
  </svg>
);

export default ThreeDotsIconImage;
